<template>
    <div id="Unassigned_Visits" class="dashboard-card d-flex">
        <CardTemplate>
            <!-- HEADER -->
            <template #header>
                <section class="card-title">
                    <span> Active Patients</span>
                </section>
            </template>
            <!-- CONTENT -->
            <!-- LOADING -->
            <template #content>
                <div class="mt-3 text-center" v-if="isLoading && !hasError">
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                    <b>Loading your active patients count</b>
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </div>
                <!-- ERROR -->
                <div class="mt-5 text-center" v-if="hasError && !isLoading">
                    <p>
                        There was a problem while fetching your active patients.
                        <br />
                        Please try again.
                    </p>
                    <button class="btn btn-primary" @click="getActivePatientsCount()">Try Again</button>
                </div>
                <!-- NO DATA -->
                <section v-if="activePatientData.length === 0 && !isLoading && !hasError" class="no-data">
                    <i class="mb-3"> Good Job! There were no active patients. </i>
                </section>
                <!-- DATA -->
                <div class="h-100 overflow-auto w-100 d-flex align-items-center p-2 active-patients">
                    <Chart type="pie" :data="chartData" :options="chartOptions" />
                    <div class="legend ms-4">
                        <table>
                            <tr
                                v-for="activePatient in activePatientData"
                                :key="activePatient.id"
                                :class="
                                    ApplicationNamesEnum.getDescriptionUsingValue(activePatient.application) ==
                                    active.label
                                        ? getProductColorClass(active.label)
                                        : 'text-black'
                                "
                            >
                                <td>
                                    {{ ApplicationNamesEnum.getDescriptionUsingValue(activePatient.application) }}
                                </td>
                                <td class="ps-3"></td>
                                <td class="ps-2"></td>
                                <td>{{ activePatient.count }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./ActivePatients.ts"></script>
